// extracted by mini-css-extract-plugin
export default {"form":"_5VQgMcvln2XZ5Ua_JegVZ"};